import ProductMain from '../product-main/product-main.js';
import { addItemFromFormToCart } from '@/js/add-to-cart';

class ProductFormModal extends ProductMain {
  /**
   * Initialize variables for the product form and variants.
   */
  initVariables() {
    super.initVariables();
    this.productURL = this.dataset.productUrl;
    this.modal = document.querySelector('[data-product-form-modal]');
  }

  /**
   * modify inherited function to render from productURL
   */
  renderSection(origin, pathname, parameters) {
    this.loadSectionFromUrl(`${this.productURL}?${parameters}`, {
      replaceState: false
    });
  }

  /**
   * Override the addItemToCart function to add the item to the cart
   * @param {*} formData
   * @param {*} ctaButton
   */
  async addItemToCart(formData, ctaButton) {
    try {
      await addItemFromFormToCart(formData, ctaButton, []);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to add item from form to cart:', error);
    }
  }

  /**
   * Updates the CTA text for Kyoto-only products in the modal
   * @returns {void}
   */
  updateKyotoOnlyText() {
    const productAddCtaElement = this.querySelector('product-add-cta');
    if (!productAddCtaElement) return;

    const button = productAddCtaElement.button;

    const isKyotoOnly = button.hasAttribute('kyoto-only-product');

    if (isKyotoOnly) {
      // Force update the text based on current button state
      productAddCtaElement.setTextBasedOnButtonState(button.disabled);
    }
  }

  afterSectionRender() {
    super.afterSectionRender();
    this.updateKyotoOnlyText();
  }
}

customElements.define('product-form-modal', ProductFormModal);
